import { UiSchema } from '@rjsf/core';
import { JSONSchema7 } from 'json-schema';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { IntakeForm } from 'views/pages/client-record/useIntakeForm';
import JsonFormContainer from '../JsonFormContainer';
import Actions from './Actions';

const uiSchema: UiSchema = {
  occupationalInfo_1: { 'ui:widget': 'radio', 'ui:options': { inline: true } },
  occupationalInfo_7: { 'ui:widget': 'radio', 'ui:options': { inline: true } },
  occupationalInfo_10: { 'ui:widget': 'textarea' }
};

interface Props {
  intakeForm: IntakeForm;
  onPrevious?: () => void;
  isSubmitting: boolean;
  onSubmit: (data: any) => void;
}

export default function OccupationalInformation({ intakeForm, onPrevious, isSubmitting, onSubmit }: Props) {
  const intl = useIntl();
  const schema: JSONSchema7 = {
    type: 'object',
    title: intl.formatMessage({ defaultMessage: 'Occupational Information' }),
    properties: {
      occupationalInfo_1: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Are you currently:' }),
        enum: [
          intl.formatMessage({ defaultMessage: 'Working' }),
          intl.formatMessage({ defaultMessage: 'Student' }),
          intl.formatMessage({ defaultMessage: 'Unemployed' }),
          intl.formatMessage({ defaultMessage: 'Disabled' }),
          intl.formatMessage({ defaultMessage: 'Retired' })
        ]
      },
      occupationalInfo_2: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'How long in present position?' })
      },
      occupationalInfo_3: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'What is/was your occupation?' })
      },
      occupationalInfo_4: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Where do you work?' })
      },
      occupationalInfo_5: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Have you ever served in the military?' })
      },
      occupationalInfo_6: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'If so, what branch and when?' })
      },
      occupationalInfo_7: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Honorable discharge' }),
        enum: [intl.formatMessage({ defaultMessage: 'Yes' }), intl.formatMessage({ defaultMessage: 'No' })]
      },
      occupationalInfo_8: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Other type discharge' })
      },
      occupationalInfo_9: {
        type: 'string',
        // title: 'If yes, are you happy with your current position?'
        title: intl.formatMessage({ defaultMessage: 'Are you happy with your current position?' })
      },
      occupationalInfo_10: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Please list any work-related stressors, if any' })
      }
    }
  };
  const [formData, setFormData] = useState(intakeForm.occupationalInfo);

  return (
    <JsonFormContainer
      noValidate
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={({ formData }) => setFormData(formData)}
      onSubmit={({ formData }) =>
        onSubmit({
          occupationalInfo: formData
        })
      }
    >
      <Actions onPrevious={onPrevious} disabled={isSubmitting} />
    </JsonFormContainer>
  );
}
